import React, { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";
import { getWishListItems } from "../redux/actions/wishlistActions";

const HeaderFavCountIcon = (props) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getWishListItems());
  }, []);

  const wishListItems =
    useSelector((state) => state.wishListReducer.result) || [];
  let wishListCount = 0;
  if (Array.isArray(wishListItems)) {
    wishListCount = wishListItems.length;
  }

  return (
    <li className=''>
      <a href='/wishlists' className='option_links' title='Wishlist'>
        <i className='uil uil-heart icon_wishlist'></i>
        <span className='noti_count1'>{wishListCount}</span>
      </a>
    </li>
  );
};

export default HeaderFavCountIcon;
